import React from "react";

import styles from "./styles.module.scss";
import classNames from "classnames";

type PageProps = {
  withFooter?: boolean;
};

export const Page: React.FC<React.PropsWithChildren<PageProps>> = ({
  children,
  withFooter,
}) => {
  return (
    <div
      className={classNames(styles.page, {
        [styles.withFooter]: withFooter,
      })}
    >
      {children}
    </div>
  );
};
